import React from 'react'
import PropTypes from 'prop-types'

function Crosshair({ x, y, xMin, xMax, yMin, yMax, symbol, color, strokeWidth = 2, ...props }) {
  return (
    <g {...props}>
      <line stroke="black" strokeDasharray="1, 2" strokeWidth="1" opacity="0.5" x1={x} x2={x} y1={yMin} y2={yMax} />
      <line stroke="black" strokeDasharray="1, 2" strokeWidth="1" opacity="0.5" x1={xMin} x2={xMax} y1={y} y2={y} />
      <path
        stroke={color}
        strokeWidth={strokeWidth}
        fill="white"
        transform={`translate(${x},${y}) rotate(45)`}
        d={symbol()}
      />
    </g>
  )
}

Crosshair.propTypes = {
  color: PropTypes.string,
  x: PropTypes.number,
  y: PropTypes.number,
  xMin: PropTypes.number,
  xMax: PropTypes.number,
  yMin: PropTypes.number,
  yMax: PropTypes.number,
  strokeWidth: PropTypes.number,
  symbol: PropTypes.func,
}

export default React.memo(Crosshair)
